import React, { useRef } from 'react';
import HTMLFlipBook from 'react-pageflip';
import './WineMenuBook.css';

const WineMenuBook = () => {
  const audioRef = useRef(null);

  const handleFlip = () => {
    if (audioRef.current) {
      audioRef.current.currentTime = 0;
      audioRef.current.play().catch(() => {}); 
    }
  };

  return (
    <div className="wine-menu-wrapper">
      <audio ref={audioRef} src="/jazz-flip.mp3" preload="auto" />
      <HTMLFlipBook width={360} height={480} size="stretch" minWidth={300} maxWidth={460} minHeight={400} maxHeight={600} mobileScrollSupport={true}  onFlip={handleFlip}>

        <div className="wine-page">
          <h2>🍷 Specialty Drink Menu</h2>
          <p>Welcome to some of our curated selection.</p>
          <p>Explore our curated wine collection, handpicked to complement your private event or catering order.</p>
        </div>
        <div className="wine-page">
          <h3>Wine</h3>
          <img src="../gallery/wine1.jpg" alt="Cabernet" />
          <p>Cahardonnay – bold & rich</p>
        </div>
        <div className="wine-page">
          <h3>Wine</h3>
          <img src="/gallery/wine2.png" alt="Chardonnay" />
          <p>Champangne – smooth & buttery</p>
        </div>
        <div className="wine-page">
          <h3>Specialty</h3>
          <img src="/gallery/wine3.png" alt="Island Blend" />
          <p>Don Julio – fresh & rich</p>
        </div>
        <div className="wine-page">
          <h3>More</h3>
          <img src="/gallery/wine4.png" alt="Island Blend" />
          <p>Book Now to recieve the full menu containing a variety of food and drink options.</p>
        </div>
      </HTMLFlipBook>
    </div>
  );
};

export default WineMenuBook;
